import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { PdfService } from './pdf.service';
import { ApplicationService } from '../application/application.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class PdfGuard implements CanActivate {
    constructor(
        private pdfService: PdfService,
        private applicationService: ApplicationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.pdfService.getPdf(this.applicationService.caseId).pipe(map(() => true));
    }
}
